import axios from "axios";
import { settings } from "./setting";

export const gestionCanalizacionId =  async (integrante_id, alerta_id) => {
    const res = await axios.get(`${settings.url}/hogar/riesgobyalert/?integrante_id=${integrante_id}&alerta_id=${alerta_id}`)
    return res.data
}